import React from 'react';
import { motion } from 'framer-motion';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  header?: React.ReactNode;
  footer?: React.ReactNode;
  hover?: boolean;
  padding?: 'none' | 'sm' | 'md' | 'lg';
}

const Card: React.FC<CardProps> = ({
  children,
  className = '',
  header,
  footer,
  hover = false,
  padding = 'md'
}) => {
  const paddingClasses = {
    none: '',
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8'
  };

  const CardWrapper = hover ? motion.div : 'div';
  const cardProps = hover ? {
    whileHover: { y: -2 },
    transition: { duration: 0.2 }
  } : {};

  return (
    <CardWrapper
      {...cardProps}
      className={`bg-[var(--color-surface)] text-[var(--color-on-surface)] rounded-lg shadow-md overflow-hidden ${hover ? 'hover:shadow-lg transition-shadow' : ''} ${className}`}
      whileHover={hover ? { y: -2 } as any : undefined}
      transition={hover ? { duration: 0.2 } : undefined}
    >
      {header && (
        <div className="border-b border-[var(--color-border)]">
          <div className={paddingClasses[padding]}>{header}</div>
        </div>
      )}
      
      <div className={paddingClasses[padding]}>{children}</div>
      
      {footer && (
        <div className="border-t border-[var(--color-border)] bg-[var(--color-background)] text-[var(--color-on-background)]">
          <div className={paddingClasses[padding]}>{footer}</div>
        </div>
      )}
    </CardWrapper>
  );
};

export default Card; 